// https://gist.github.com/aurbano/4693462
export function distance(p1, p2) {
    var dx = p2.x - p1.x;
    var dy = p2.y - p1.y;
    return Math.sqrt(dx * dx + dy * dy);
}
export function distanceApprox(p1, p2) {
    // Approximation by using octagons approach
    var x = p2.x - p1.x;
    var y = p2.y - p1.y;
    return 1.426776695 * Math.min(0.7071067812 * (Math.abs(x) + Math.abs(y)), Math.max(Math.abs(x), Math.abs(y)));
}
